import React from 'react'
import { Switch } from 'react-router-dom'
import PublicRoutes from './PublicRoutes'
import PrivateRoutes from './PrivateRoutes'

import Login from '../views/auth/Login/index'
import Dashboard from '../views/Dashboard'
import UserManagement from '../../src/views/Users/UserManagement/index'
import UserContest from '../../src/views/Contest/UserContest/index'
import CMSMnagement from '../../src/views/CMS/index'
import AddCMS from '../views/CMS/AddCMS/index'
import AdminContest from '../../src/views/AdminContest/index'
import AdminUser from '../views/Users/AdminUser'
import IndexAdminUser from '../views/Users/AdminUser/AddAdminUser'

function Routes () {
  return (
    <>
      <Switch>
        <PublicRoutes path="/auth/login" component={Login} exact />
        <PrivateRoutes path="/" component={Dashboard} exact />
        <PrivateRoutes path='/users/usermanagement' component={UserManagement} exact/>
        <PrivateRoutes path='/contest/user-contest' component={UserContest} exact />
        <PrivateRoutes path='/cms/cms-management/addcms' component={AddCMS} exact/>
        <PrivateRoutes path='/cms/cms-management' component={CMSMnagement} exact />
        <PrivateRoutes path='/contest/admin-contest' component={AdminContest} exact/>
        <PrivateRoutes path='/users/admin-user/add-admin-user' component={IndexAdminUser} />
        <PrivateRoutes path='/users/admin-user' component={AdminUser} />
      </Switch>
    </>
  )
}

export default Routes
